import Image from "next/image";

import PropTypes from "prop-types";

function Banner({ imageUrl, className, imageOptions }) {
  return (
    <div className={`relative ${className}`}>
      <Image
        src={imageUrl}
        fill
        alt="Banner"
        priority={imageOptions.priority}
        quality={imageOptions.quality}
        className={imageOptions.style}
      />
    </div>
  );
}

Banner.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  className: PropTypes.string,
  imageOptions: PropTypes.object,
};

Banner.defaultProps = {
  className: "aspect-[4.96/1]",
  imageOptions: {
    priority: false,
    quality: "50",
  },
};

export default Banner;
